<template>
  <div class="materials-quote-statistics">
    <!-- Quote Values by Period -->
    <div class="stats-section mb-4">
      <h5 class="section-title">📊 Materials Quote Statistics</h5>
      <div class="value-periods-grid">
        <div class="value-period-card">
          <div class="period-left">
            <div class="period-header">
              <div class="period-icon">📅</div>
              <div class="period-title">This Week</div>
            </div>
            
            <div class="period-stats">
              <div class="period-stat">
                <span class="stat-label">Count</span>
                <span class="stat-value">{{ (stats.valuesByPeriod && stats.valuesByPeriod.thisWeek && stats.valuesByPeriod.thisWeek.count) || 0 }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Total Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisWeek && stats.valuesByPeriod.thisWeek.total) || 0) }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Avg Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisWeek && stats.valuesByPeriod.thisWeek.avg) || 0) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="value-period-card">
          <div class="period-left">
            <div class="period-header">
              <div class="period-icon">📆</div>
              <div class="period-title">This Month</div>
            </div>
            
            <div class="period-stats">
              <div class="period-stat">
                <span class="stat-label">Count</span>
                <span class="stat-value">{{ (stats.valuesByPeriod && stats.valuesByPeriod.thisMonth && stats.valuesByPeriod.thisMonth.count) || 0 }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Total Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisMonth && stats.valuesByPeriod.thisMonth.total) || 0) }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Avg Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisMonth && stats.valuesByPeriod.thisMonth.avg) || 0) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="value-period-card">
          <div class="period-left">
            <div class="period-header">
              <div class="period-icon">📈</div>
              <div class="period-title">This Quarter</div>
            </div>
            
            <div class="period-stats">
              <div class="period-stat">
                <span class="stat-label">Count</span>
                <span class="stat-value">{{ (stats.valuesByPeriod && stats.valuesByPeriod.thisQuarter && stats.valuesByPeriod.thisQuarter.count) || 0 }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Total Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisQuarter && stats.valuesByPeriod.thisQuarter.total) || 0) }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Avg Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisQuarter && stats.valuesByPeriod.thisQuarter.avg) || 0) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="value-period-card">
          <div class="period-left">
            <div class="period-header">
              <div class="period-icon">🗓️</div>
              <div class="period-title">This Year</div>
            </div>
            
            <div class="period-stats">
              <div class="period-stat">
                <span class="stat-label">Count</span>
                <span class="stat-value">{{ (stats.valuesByPeriod && stats.valuesByPeriod.thisYear && stats.valuesByPeriod.thisYear.count) || 0 }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Total Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisYear && stats.valuesByPeriod.thisYear.total) || 0) }}</span>
              </div>
              <div class="period-stat">
                <span class="stat-label">Avg Value</span>
                <span class="stat-value">${{ formatCurrency((stats.valuesByPeriod && stats.valuesByPeriod.thisYear && stats.valuesByPeriod.thisYear.avg) || 0) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Status Breakdown -->
    <!-- <div class="stats-section mb-4" v-if="stats.quotesByStatus && stats.quotesByStatus.length">
      <h5 class="section-title">📋 Status Breakdown</h5>
      <div class="status-breakdown">
        <div 
          v-for="status in stats.quotesByStatus" 
          :key="status._id"
          class="status-item"
        >
          <div class="status-info">
            <span class="status-name">{{ getStatusText(status._id) }}</span>
            <span class="status-count">{{ status.count }}</span>
          </div>
          <div class="status-bar">
            <div 
              class="status-fill"
              :class="getStatusClass(status._id)"
              :style="{ width: getStatusPercentage(status.count) + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Recent Activity -->
    <!-- <div class="stats-section" v-if="stats.recentActivity">
      <h5 class="section-title">⚡ Recent Activity</h5>
      <div class="recent-activity">
        <div class="activity-summary">
          <div class="activity-item">
            <span class="activity-label">Quotes Created Today:</span>
            <span class="activity-value">{{ stats.recentActivity.createdToday || 0 }}</span>
          </div>
          <div class="activity-item">
            <span class="activity-label">Follow-ups Due:</span>
            <span class="activity-value text-warning">{{ stats.recentActivity.followUpsDue || 0 }}</span>
          </div>
          <div class="activity-item">
            <span class="activity-label">Overdue Follow-ups:</span>
            <span class="activity-value text-danger">{{ stats.recentActivity.followUpsOverdue || 0 }}</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'MaterialsQuoteStatistics',
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    totalQuotesByStatus() {
      if (!this.stats.quotesByStatus || !this.stats.quotesByStatus.length) return 0
      return this.stats.quotesByStatus.reduce((total, status) => total + status.count, 0)
    }
  },
  methods: {
    formatCurrency(amount) {
      if (!amount && amount !== 0) return '0.00'
      return parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    getStatusText(status) {
      const statusMap = {
        'DRAFT': 'Draft',
        'OPEN': 'Open',
        'SOLD': 'Sold',
        'REJECTED': 'Rejected',
        'EXPIRED': 'Expired'
      }
      return statusMap[status] || status
    },

    getStatusClass(status) {
      const classMap = {
        'DRAFT': 'status-draft',
        'OPEN': 'status-open',
        'SOLD': 'status-sold',
        'REJECTED': 'status-rejected',
        'EXPIRED': 'status-expired'
      }
      return classMap[status] || 'status-default'
    },

    getStatusPercentage(count) {
      if (!this.totalQuotesByStatus) return 0
      return Math.round((count / this.totalQuotesByStatus) * 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.materials-quote-statistics {
  .section-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  .value-periods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .value-period-card {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    transition: box-shadow 0.15s ease-in-out;

    &:hover {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }

    .period-header {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;

      .period-icon {
        font-size: 1.5rem;
        margin-right: 0.75rem;
      }

      .period-title {
        font-size: 1.1rem;
        font-weight: 600;
        color: #495057;
      }
    }

    .period-stats {
      .period-stat {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }

        .stat-label {
          color: #6c757d;
          font-size: 0.9rem;
        }

        .stat-value {
          font-weight: 600;
          color: #212529;
          font-size: 0.95rem;
        }
      }
    }
  }

  .status-breakdown {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.25rem;

    .status-item {
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }

      .status-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5rem;

        .status-name {
          font-weight: 500;
          color: #495057;
        }

        .status-count {
          font-weight: 600;
          color: #212529;
        }
      }

      .status-bar {
        height: 8px;
        background: #e9ecef;
        border-radius: 4px;
        overflow: hidden;

        .status-fill {
          height: 100%;
          transition: width 0.3s ease;

          &.status-draft {
            background: #6c757d;
          }

          &.status-open {
            background: #17a2b8;
          }

          &.status-sold {
            background: #28a745;
          }

          &.status-rejected {
            background: #dc3545;
          }

          &.status-expired {
            background: #ffc107;
          }

          &.status-default {
            background: #007bff;
          }
        }
      }
    }
  }

  .recent-activity {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 1.25rem;

    .activity-summary {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 1rem;

      .activity-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem;
        background: #f8f9fa;
        border-radius: 0.375rem;

        .activity-label {
          color: #6c757d;
          font-size: 0.9rem;
        }

        .activity-value {
          font-weight: 600;
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
